import React from 'react'
import { Form } from 'semantic-ui-react'

export default class CodeField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Input
        fluid
        label="Code"
        placeholder="A880880"
        onChange={e => onChange('code', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/codeField.js